import { Operator as FilterOperator } from '@deephaven/filters';
export class StorageUtils {
  static makeSortConfig(columnName, direction) {
    return {
      column: columnName,
      direction
    };
  }
  static makeFilterConfig(filters) {
    var filterItems = [];
    var filterOperators = [];
    filters.forEach((filterItem, i) => {
      filterItems.push(filterItem);
      if (i > 0) {
        filterOperators.push(FilterOperator.and);
      }
    });
    return {
      filterItems,
      filterOperators
    };
  }
  static combineFilterConfigs(config1, config2) {
    var operator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FilterOperator.and;
    return {
      filterItems: [...config1.filterItems, ...config2.filterItems],
      filterOperators: [...config1.filterOperators, operator, ...config2.filterOperators]
    };
  }
  static makeFilterItem(columnName, type, value) {
    return {
      columnName,
      type,
      value
    };
  }
}
export default StorageUtils;
//# sourceMappingURL=StorageUtils.js.map